import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import '../style/OrdersPage.css';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

const PurchaseInvoice = () => {
    const [invoiceReports, setInvoiceReports] = useState([]);
    const [invoiceLoading, setInvoiceLoading] = useState(true);

    const user = auth.currentUser;
    if (!user) {
        throw new Error("User not logged in");
    }

    const fetchInvoiceReports = async () => {
        try {
            const invoicesCollection = collection(db, 'users', user.uid, 'invoices');
            
            const unsubscribe = onSnapshot(invoicesCollection, (snapshot) => {
                const invoicesList = snapshot.docs.map(doc => ({ 
                    id: doc.id, 
                    ...doc.data() 
                }));
                
                // Sort by generation date (newest first)
                invoicesList.sort((a, b) => new Date(b.generationDate) - new Date(a.generationDate));
                
                setInvoiceReports(invoicesList);
                setInvoiceLoading(false);
            });

            return () => unsubscribe();
        } catch (error) {
            console.error("Error fetching invoice reports:", error);
            setInvoiceLoading(false);
        }
    };

    useEffect(() => {
        fetchInvoiceReports();
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return 'NA';
        return new Date(dateString).toLocaleDateString('en-GB');
    };

    if (invoiceLoading) {
        return <div>Loading invoice reports...</div>;
    }

    return (
        <div className="flex h-screen bg-gray-50">
            {/* Sidebar */}
            <Sidebar />

            {/* Main content */}
            <div className="flex-1 flex flex-col min-w-0 overflow-hidden md:ml-64">
                <Header />

                <div className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
                    <h1>Purchase Invoice</h1>
                    
                    {/* Monthly invoice transition notice */}
                    <div style={{ 
                        fontSize: '18px', 
                        fontWeight: 'bold', 
                        textAlign: 'center', 
                        margin: '20px 0', 
                        color: '#333',
                        backgroundColor: '#f0f8ff',
                        padding: '15px',
                        borderRadius: '8px',
                        border: '2px solid #007bff'
                    }}>
                        Starting June 1st, 2025 You'll receive a single monthly invoice instead of one for each order.
                    </div>

                    {/* Invoice Reports Table */}
                    <div style={{ marginBottom: '30px' }}>
                        {invoiceReports.length > 0 ? (
                            <table className="orders-table">
                                <thead>
                                    <tr>
                                        <th>From Date</th>
                                        <th>To Date</th>
                                        <th>Product Invoice</th>
                                        <th>Shipping Invoice</th>
                                        <th>Packaging Invoice</th>
                                        <th>Excel Report</th>
                                        <th>Total Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoiceReports.map((report) => (
                                        <tr key={report.id}>
                                            <td>{formatDate(report.fromDate)}</td>
                                            <td>{formatDate(report.toDate)}</td>
                                            <td>
                                                {report.invoices?.product ? (
                                                    <button 
                                                        onClick={() => window.open(report.invoices.product.invoiceUrl, '_blank')}
                                                        className="download-invoice-btn"
                                                        style={{ fontSize: '12px', padding: '5px 8px' }}
                                                    >
                                                        Download (₹{report.invoices.product.amount})
                                                    </button>
                                                ) : (
                                                    <span style={{ color: '#999' }}>NA</span>
                                                )}
                                            </td>
                                            <td>
                                                {report.invoices?.shipping ? (
                                                    <button 
                                                        onClick={() => window.open(report.invoices.shipping.invoiceUrl, '_blank')}
                                                        className="download-invoice-btn"
                                                        style={{ fontSize: '12px', padding: '5px 8px' }}
                                                    >
                                                        Download (₹{report.invoices.shipping.amount})
                                                    </button>
                                                ) : (
                                                    <span style={{ color: '#999' }}>NA</span>
                                                )}
                                            </td>
                                            <td>
                                                {report.invoices?.packaging ? (
                                                    <button 
                                                        onClick={() => window.open(report.invoices.packaging.invoiceUrl, '_blank')}
                                                        className="download-invoice-btn"
                                                        style={{ fontSize: '12px', padding: '5px 8px' }}
                                                    >
                                                        Download (₹{report.invoices.packaging.amount})
                                                    </button>
                                                ) : (
                                                    <span style={{ color: '#999' }}>NA</span>
                                                )}
                                            </td>
                                            <td>
                                                {report.excelReportUrl ? (
                                                    <button 
                                                        onClick={() => window.open(report.excelReportUrl, '_blank')}
                                                        className="download-invoice-btn"
                                                        style={{ fontSize: '12px', padding: '5px 8px', backgroundColor: '#28a745' }}
                                                    >
                                                        Download Excel
                                                    </button>
                                                ) : (
                                                    <span style={{ color: '#999' }}>NA</span>
                                                )}
                                            </td>
                                            <td style={{ fontWeight: 'bold', color: '#007bff' }}>
                                                ₹{report.totalAmount || 'NA'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p style={{ 
                                textAlign: 'center', 
                                color: '#666', 
                                fontStyle: 'italic',
                                padding: '20px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px'
                            }}>
                                No monthly invoice reports found.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PurchaseInvoice;